import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { PriceList, priceLisType } from '../../types/slices/priceLisType'

const initialState: priceLisType =
{
    status: ApiStatus.FETCHED,
    priceList: [],
    priceListSelected: {} as PriceList,
    errorMessage: undefined,
    action: ''
}

const priceListSlice = createSlice({
    name: 'priceListSlice',
    initialState,
    reducers: {
        onFetchPriceList (state, { payload }: { payload: PriceList[]}) {
        state.status = ApiStatus.FETCHED
        state.priceList = payload
        state.errorMessage = undefined
        },
        onSetSelectedPriceList (state, { payload }: { payload: PriceList }) {
        state.priceListSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
        state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
        state.action = payload
        },
    }
})

export const selectPriceListState = (state: RootState) => state.priceListSlice
export default priceListSlice.reducer
export const {
    onFetchPriceList,
    onSetSelectedPriceList,
    changeStatus,
    setAction,
} = priceListSlice.actions
